import Routes from '../data/routes'
import Cart from '../typings/Cart'
import Order from '../typings/Order'

import mapCheckoutDataToCheckoutStepsFlags from './map-checkout-data-to-checkout-steps-flags'

type ActiveCheckoutStep =
  | { type: 'route'; route: string }
  | { type: 'error'; error: 'no-available-online-product' | 'could-not-calculate-initial-active-step' }

const calculateActiveCheckoutStep = (data: Cart | Order): ActiveCheckoutStep => {
  const {
    isBookableItemCart,
    isProductItemCart,
    hasProductToSelect,
    hasSelectedProduct,
    hasAdditionalInformation,
    hasSomethingToPay,
    isOrderPaid,
    hasBufferPage,
  } = mapCheckoutDataToCheckoutStepsFlags(data)

  if (data.__typename === 'Cart') {
    const isProductSelection = hasProductToSelect
    const isAdditionalInformation =
      (isBookableItemCart && hasSelectedProduct && hasAdditionalInformation) ||
      (isProductItemCart && hasAdditionalInformation)

    if (isProductSelection) {
      return { type: 'route', route: Routes.CHOOSE_PRODUCT }
    }

    if (hasBufferPage) {
      return { type: 'route', route: Routes.REVIEW_INFORMATION }
    }

    if (isAdditionalInformation) {
      return { type: 'route', route: Routes.ADDITIONAL_INFORMATION }
    }

    if (hasSomethingToPay) {
      return { type: 'route', route: Routes.PAYMENT }
    }

    if (!hasProductToSelect) {
      return { type: 'error', error: 'no-available-online-product' }
    }
  }

  if (data.__typename === 'Order') {
    if (hasSomethingToPay && !isOrderPaid) {
      return { type: 'route', route: Routes.PAYMENT }
    }

    return { type: 'route', route: Routes.CONFIRMATION }
  }

  return { type: 'error', error: 'could-not-calculate-initial-active-step' }
}

export default calculateActiveCheckoutStep
